﻿
<div class="dsk-wrap" *ngIf="loading">
  <div class="dsk-toolbar">
    <div class="dsk-cell dsk-pulse" style="width:180px;height:22px;border-radius:6px"></div>
    <div class="dsk-spacer"></div>
    <div class="dsk-btn dsk-pulse"></div>
  </div>
  <div class="dsk-split dsk-split-1-2">
    <div class="dsk-panel">
      <div class="dsk-panel-head">
        <div class="dsk-cell dsk-pulse" style="flex:1;height:13px"></div>
        <div class="dsk-cell dsk-pulse" style="width:60px;height:13px"></div>
      </div>
      <div class="dsk-panel-body">
        <div class="dsk-list-item dsk-pulse" *ngFor="let d of [1,2,3,4,5,6,7]" style="height:62px;display:flex;align-items:center;padding:0 14px;gap:12px;background:#fff;border-radius:9px;border:1px solid #ece9e6">
        </div>
      </div>
    </div>
    <div class="dsk-panel">
      <div class="dsk-panel-head">
        <div class="dsk-cell dsk-pulse" style="width:32px;height:32px;border-radius:8px"></div>
        <div style="display:flex;flex-direction:column;gap:6px;flex:1">
          <div class="dsk-cell dsk-pulse" style="width:140px;height:16px"></div>
          <div class="dsk-cell dsk-pulse" style="width:90px;height:12px"></div>
        </div>
        <div class="dsk-btn-sm dsk-pulse"></div>
      </div>
      <div class="dsk-panel-body" style="gap:14px">
        <div class="dsk-stat-row">
          <div class="dsk-stat dsk-pulse" style="height:72px" *ngFor="let s of [1,2,3]"></div>
        </div>
        <div class="dsk-cell dsk-pulse" style="height:16px;width:120px"></div>
        <div *ngFor="let m of [1,2,3,4]" style="display:flex;align-items:center;gap:12px;padding:10px 0;border-bottom:1px solid #f0eeec">
          <div class="dsk-avatar dsk-pulse" style="border-radius:50%"></div>
          <div style="display:flex;flex-direction:column;gap:5px;flex:1">
            <div class="dsk-cell dsk-pulse" style="width:130px;height:13px"></div>
            <div class="dsk-cell dsk-pulse" style="width:85px;height:11px"></div>
          </div>
          <div class="dsk-badge dsk-pulse" style="width:56px;border-radius:20px"></div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="dp-page" *ngIf="!loading">

  <div class="dp-topbar">
    <div class="dp-topbar-left">
      <ng-container *ngIf="!selectedDept">
        <span class="dp-page-title">Departments</span>
      </ng-container>
      <ng-container *ngIf="selectedDept && !selectedTeamInDept">
        <span class="bc-link" (click)="selectedDept=null">All Departments</span>
        <span class="bc-sep">›</span>
        <span class="bc-cur">{{ selectedDept.name }}</span>
      </ng-container>
      <ng-container *ngIf="selectedDept && selectedTeamInDept">
        <span class="bc-link" (click)="selectedDept=null; selectedTeamInDept=null">All Departments</span>
        <span class="bc-sep">›</span>
        <span class="bc-link" (click)="selectedTeamInDept=null">{{ selectedDept.name }}</span>
        <span class="bc-sep">›</span>
        <span class="bc-cur">{{ selectedTeamInDept.name }}</span>
      </ng-container>
    </div>
    <button class="dp-create-btn" *ngIf="permissions.canAddInModule('departments')" (click)="showCreateDept=true">
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
      New Department
    </button>
  </div>

  <div class="dp-layout">

    <div class="dp-list-col">
      <div class="dp-list-items">
        <div class="dp-list-item"
          *ngFor="let dept of departments"
          [class.dp-list-item--active]="selectedDept?.id === dept.id"
          (click)="selectDept(dept)">
          <div class="dp-list-color" [style.background]="dept.color || '#8b1a1a'"></div>
          <div class="dp-list-info">
            <div class="dp-list-name">{{ dept.name }}</div>
            <div class="dp-list-meta">{{ getEmployeeCount(dept.id) }} employees · {{ getDeptTeams(dept.id).length }} teams</div>
          </div>
          <div class="dp-list-avatars">
            <div class="tc-av" *ngFor="let e of getDeptEmployees(dept.id).slice(0,3)" [style.background]="getAvatarColor(e)">{{ getInitials(e) }}</div>
          </div>
        </div>

        <div class="dp-list-empty" *ngIf="departments.length === 0">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" style="color:#c9b8b4;margin-bottom:6px"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 00-4 0v2M8 7V5a2 2 0 014 0v2"/></svg>
          <span>No departments yet</span>
          <button class="btn-primary" style="margin-top:10px;font-size:11px;padding:7px 14px" (click)="showCreateDept=true">Create First</button>
        </div>
      </div>
    </div>

    <div class="dp-detail-panel">

      <div class="dp-detail-empty" *ngIf="!selectedDept">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" style="color:#d4c8c5;margin-bottom:12px"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 00-4 0v2M8 7V5a2 2 0 014 0v2"/></svg>
        <div class="dp-detail-empty-title">Select a department</div>
        <div class="dp-detail-empty-sub">Click any department on the left to view its teams and members</div>
      </div>

      <ng-container *ngIf="selectedDept && !selectedTeamInDept">

        <div class="dp-detail-head" [style.border-left-color]="selectedDept.color || '#8b1a1a'">
          <div class="dp-detail-head-left">
            <div class="dp-dept-avatar" [style.background]="selectedDept.color || '#8b1a1a'">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 00-4 0v2M8 7V5a2 2 0 014 0v2"/></svg>
            </div>
            <div>
              <div class="dp-detail-name">{{ selectedDept.name }}</div>
              <div class="dp-detail-desc">{{ selectedDept.description || 'No description' }}</div>
            </div>
          </div>
          <div class="dp-detail-actions">
            <button class="tdp-icon-btn" *ngIf="permissions.canEditInModule('departments')" (click)="openEditDept(selectedDept)" title="Edit">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
            </button>
            <button class="tdp-icon-btn tdp-icon-btn--danger" *ngIf="permissions.canDeleteInModule('departments')" (click)="deleteDepartment(selectedDept.id)" title="Delete">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4h6v2"/></svg>
            </button>
          </div>
        </div>

        <div class="dp-info-strip">
          <div class="dp-info-item">
            <span class="dp-info-label">Head</span>
            <span class="dp-info-val">{{ getHead(selectedDept.headId) ? (getHead(selectedDept.headId).firstName + ' ' + getHead(selectedDept.headId).lastName) : '—' }}</span>
          </div>
          <div class="dp-info-sep"></div>
          <div class="dp-info-item">
            <span class="dp-info-label">Teams</span>
            <span class="dp-info-val">{{ getDeptTeams(selectedDept.id).length }}</span>
          </div>
          <div class="dp-info-sep"></div>
          <div class="dp-info-item">
            <span class="dp-info-label">Employees</span>
            <span class="dp-info-val">{{ getEmployeeCount(selectedDept.id) }}</span>
          </div>
        </div>

        <div class="dp-section-label">
          <span>Teams</span>
          <span class="dp-section-count">{{ getDeptTeams(selectedDept.id).length }}</span>
        </div>

        <div class="dp-teams-grid">
          <div class="dp-team-card" *ngFor="let team of getDeptTeams(selectedDept.id)" (click)="selectTeamInDept(team)">
            <div class="dp-team-card-top">
              <div class="dp-team-name">{{ team.name }}</div>
              <span class="bd" [ngClass]="team.status === 'active' ? 'bgr' : 'bcr'" style="font-size:9px">{{ (team.status || 'active') | titlecase }}</span>
            </div>
            <div class="dp-team-meta">{{ getTeamShiftName(team.defaultShiftId) }} · {{ getTeamLeadName(team.teamLeadId) }}</div>
            <div class="dp-team-bottom">
              <div class="tl-avatars" style="display:flex">
                <div class="tc-av" *ngFor="let e of getTeamMemberAvatars(team.id)" [style.background]="getAvatarColor(e)">{{ getInitials(e) }}</div>
              </div>
              <span class="dp-team-count">{{ getTeamMemberCount(team.id) }} members</span>
            </div>
          </div>

          <div class="dp-team-card dp-team-empty-card" *ngIf="getDeptTeams(selectedDept.id).length === 0">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" style="color:#c9b8b4;margin-bottom:6px"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/></svg>
            <span style="font-size:11px;color:#b0a09e">No teams linked yet</span>
          </div>
        </div>

        <div class="dp-section-label" style="margin-top:20px">
          <span>Employees</span>
          <span class="dp-section-count">{{ getEmployeeCount(selectedDept.id) }}</span>
        </div>
        <div class="dp-emp-grid">
          <div class="dp-emp-card" *ngFor="let e of deptEmployeesFull(selectedDept.id)">
            <div class="tc-av" [style.background]="getAvatarColor(e)">{{ getInitials(e) }}</div>
            <div class="dp-emp-info">
              <div class="dp-emp-name">{{ e.firstName }} {{ e.lastName }}</div>
              <div class="dp-emp-sub">{{ e.employeeId }}<span *ngIf="e.designation"> · {{ e.designation }}</span></div>
            </div>
          </div>
          <div class="dp-emp-none" *ngIf="deptEmployeesFull(selectedDept.id).length === 0">No employees in this department yet.</div>
        </div>

      </ng-container>

      <ng-container *ngIf="selectedDept && selectedTeamInDept">

        <div class="dp-detail-head">
          <div class="dp-detail-head-left">
            <div class="dp-team-avatar" [style.background]="getAvatarColor({firstName: selectedTeamInDept.name, lastName: ''})">
              {{ selectedTeamInDept.name.charAt(0) }}
            </div>
            <div>
              <div class="dp-detail-name">{{ selectedTeamInDept.name }}</div>
              <div class="dp-detail-desc">Lead: {{ getTeamLeadName(selectedTeamInDept.teamLeadId) }} · {{ getTeamShiftName(selectedTeamInDept.defaultShiftId) }} shift</div>
            </div>
          </div>
          <span class="bd" [ngClass]="selectedTeamInDept.status === 'active' ? 'bgr' : 'bcr'">{{ (selectedTeamInDept.status || 'active') | titlecase }}</span>
        </div>

        <div class="dp-section-label">
          <span>Members</span>
          <span class="dp-section-count">{{ getTeamMemberCount(selectedTeamInDept.id) }}</span>
        </div>

        <div class="dp-members-list">
          <div class="dp-member-row" *ngFor="let emp of getTeamMembers(selectedTeamInDept.id)">
            <div class="av" [style.background]="getAvatarColor(emp)">{{ getInitials(emp) }}</div>
            <div class="dp-member-info">
              <div class="dp-member-name">{{ emp.firstName }} {{ emp.lastName }}</div>
              <div class="dp-member-sub">{{ emp.designation || emp.employeeId || '—' }}</div>
            </div>
            <span class="bd" [ngClass]="emp.status === 'active' ? 'bgr' : 'brr'" style="font-size:9px;margin-left:auto">{{ (emp.status || 'active') | titlecase }}</span>
          </div>

          <div class="dp-no-members" *ngIf="getTeamMembers(selectedTeamInDept.id).length === 0">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" style="color:#c9b8b4;margin-bottom:6px"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/></svg>
            <span>No members in this team yet</span>
          </div>
        </div>

      </ng-container>

    </div>
  </div>

</div>

<div *ngIf="loading" class="loading-container">
  <mat-spinner diameter="40"></mat-spinner>
</div>

<div class="sd-overlay" [class.open]="showCreateDept" (click)="showCreateDept=false"></div>
<div class="sd-drawer" [class.open]="showCreateDept">
  <div class="sd-head">
    <div class="sd-head-info">
      <div class="sd-head-title">New Department</div>
      <div class="sd-head-sub">Fill in the details to create a department</div>
    </div>
    <button class="sd-close" (click)="showCreateDept=false">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
    </button>
  </div>
  <div class="sd-body">
    <div class="fg">
      <label class="fl">Department Name <span class="sd-req">*</span></label>
      <input class="fi" [(ngModel)]="form.name" placeholder="e.g. Engineering">
    </div>
    <div class="fg">
      <label class="fl">Description</label>
      <textarea class="fi" [(ngModel)]="form.description" placeholder="Brief department purpose…" rows="3"></textarea>
    </div>
    <div class="fg">
      <label class="fl">Department Head</label>
      <app-custom-select [(ngModel)]="form.headId" [options]="employees" bindValue="id" [labelFn]="empNameFn" placeholder="Select head (optional)"></app-custom-select>
    </div>
    <div class="fg">
      <label class="fl">Color</label>
      <div style="display:flex;align-items:center;gap:12px">
        <input type="color" [(ngModel)]="form.color" style="width:44px;height:36px;border:1.5px solid #ede6dc;border-radius:8px;cursor:pointer;padding:2px">
        <div style="width:32px;height:32px;border-radius:8px;border:1.5px solid #ede6dc" [style.background]="form.color"></div>
        <span style="font-size:11px;color:#a07055">{{ form.color }}</span>
      </div>
    </div>
  </div>
  <div class="sd-foot">
    <button class="btn-primary" (click)="submitDepartment()" [disabled]="submitting || !form.name">
      {{ submitting ? 'Creating…' : 'Create Department' }}
    </button>
    <button class="btn-outline" (click)="showCreateDept=false">Cancel</button>
  </div>
</div>

<div class="sd-overlay" [class.open]="showEditDialog" (click)="showEditDialog=false"></div>
<div class="sd-drawer" [class.open]="showEditDialog">
  <div class="sd-head">
    <div class="sd-head-info">
      <div class="sd-head-title">Edit Department</div>
      <div class="sd-head-sub">Update department details</div>
    </div>
    <button class="sd-close" (click)="showEditDialog=false">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
    </button>
  </div>
  <div class="sd-body">
    <div class="fg">
      <label class="fl">Department Name <span class="sd-req">*</span></label>
      <input class="fi" [(ngModel)]="editForm.name" placeholder="Department name">
    </div>
    <div class="fg">
      <label class="fl">Description</label>
      <textarea class="fi" [(ngModel)]="editForm.description" placeholder="Brief department purpose…" rows="3"></textarea>
    </div>
    <div class="fg">
      <label class="fl">Department Head</label>
      <app-custom-select [(ngModel)]="editForm.headId" [options]="employees" bindValue="id" [labelFn]="empNameFn" placeholder="Select head (optional)"></app-custom-select>
    </div>
    <div class="fg">
      <label class="fl">Color</label>
      <div style="display:flex;align-items:center;gap:12px">
        <input type="color" [(ngModel)]="editForm.color" style="width:44px;height:36px;border:1.5px solid #ede6dc;border-radius:8px;cursor:pointer;padding:2px">
        <div style="width:32px;height:32px;border-radius:8px;border:1.5px solid #ede6dc" [style.background]="editForm.color"></div>
        <span style="font-size:11px;color:#a07055;font-weight:600">{{ editForm.color }}</span>
      </div>
    </div>
  </div>
  <div class="sd-foot">
    <button class="btn-primary" (click)="saveEditDept()" [disabled]="submitting || !editForm.name">
      {{ submitting ? 'Saving…' : 'Save Changes' }}
    </button>
    <button class="btn-outline" (click)="showEditDialog=false">Cancel</button>
  </div>
</div>

